export default function validatePasswordLength(value) {
  return typeof value === 'string' && value.length >= 6
}
